<template>
  <div class="formUserInfo">
    <div class="wxchatBorderLeft">
      <div class="flex title">
        <h3>好友列表</h3>
        <i class="el-icon-circle-plus" @click="buddyDia"></i>
      </div>
      <el-input v-model="friend" suffix-icon="el-icon-search" class="contactName" placeholder="搜索好友"
                @change="getSearch"></el-input>
      <div class="maxHeight">
        <div class="newFriend">
          <p class="smallTit">新的朋友</p>
          <div class="flex request" @click="change(1,1)" :class="active==1?'activeR':''">
            <el-avatar :size="40" :src="request"></el-avatar>
            <div class="right flex">
              <span class="text">好友申请</span>
              <el-badge :value="friendApply.value" :max="99" v-show="friendApply.value>0"></el-badge>
            </div>
          </div>
        </div>
        <div class="newFriend">
          <p class="smallTit">群聊</p>
          <div v-infinite-scroll="loadGroup" class="loadGroup">
            <template v-for="(item,index) in groupChat.group">
              <div class="flex request" @click="change(2,index+2,item)" :key="index"
                   :class="active==index+2?'activeR':''">
                <el-avatar :size="40" src="/static/imgs/chat_group.png"></el-avatar>
                <div class="right flex">
                  <span class="text">{{ item.chatName ? item.chatName : (item.masterName + '创建的群聊') }}({{item.memberNum}})</span>
                </div>
              </div>
            </template>
          </div>

        </div>
        <div class="newFriend">
          <p class="smallTit">医生好友</p>
          <div v-infinite-scroll="getFriendList" class="loadGroup">
            <template v-for="(item,index) in doctorChat.doctorList">
              <div class="flex request" :key="index" @click="setDoctorChat(item)">
                <el-avatar :size="40" v-if="item.avatar" :src="item.avatar"></el-avatar>
                <el-avatar :size="40" v-else src="/static/default_imgs/avatar.png"></el-avatar>
                <div class="right flex">
                  <span class="text">{{ item.contactAlias }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="rightChat">
      <template v-if="activeType==1">
        <div class="wxchatBorderRightTop">好友申请</div>
        <div v-infinite-scroll="getRequest" class="requestList"
             infinite-scroll-distance="10">
          <div v-for="(item,index) in friendApply.rows" class="flex rows" :key="index">
            <el-avatar :size="40" :src="item.avatar" fit="cover"></el-avatar>
            <div class="applicant">
              <p class="applicantName">{{ item.applicantName }}</p>
              <p>{{ item.greetContent }}</p>
            </div>
            <div class="approveStatus">
              <template v-if="item.approveStatus==1">
                <el-button size="mini" @click="isAccept(item.id,2)">接受</el-button>
                <el-button size="mini" plain @click="isAccept(item.id,3)">拒绝</el-button>
              </template>
              <template v-if="item.approveStatus==2">已接受</template>
              <template v-if="item.approveStatus==3">已拒绝</template>
            </div>
          </div>
          <div class="flex empty" v-if="friendApply.rows.length==0">
            <img src="../../assets/img/empty.png" alt="">
          </div>
        </div>
      </template>
      <template v-if="activeType==2">
        <div class="wxchatBorderRightTop">{{ groupChat.chatName }}({{ groupChat.memberNum }})</div>
        <div class="requestList" style="height: 85%">
          <div v-for="(obj,ind) in groupChat.members" class="flex rows" :key="ind">
            <el-avatar :size="40" v-if="obj.memberHeadImg" :src="obj.memberHeadImg"></el-avatar>
            <el-avatar :size="40" v-else src="/static/default_imgs/avatar.png"></el-avatar>
            <div class="applicant" style="width: 93%;">{{ obj.nickname }}</div>
          </div>
        </div>
        <el-button
            size="mini" @click="setChat"
            style="margin:20px auto 0;display: block;background: #567BFF;color: #FFFFFF;border: none">发消息
        </el-button>
      </template>
    </div>
    <!--    添加好友-->
    <el-dialog
        class="buddy"
        top="0" :close-on-click-modal="false"
        :visible.sync="buddy" :close-on-press-escape="false"
        width="300px">
      <template slot="title"><span>添加好友</span></template>
      <el-form ref="form" :model="form" class="formAdd">
        <el-select
            v-model="form.name"
            value-key="id"
            filterable
            remote
            placeholder="请输入医生姓名"
            no-data-text="无匹配数据"
            :remote-method="remoteMethod"
            @change="searchSelect"
            @clear="clear"
            clearable
        >
          <el-option
              v-for="item in regionDataList"
              :key="item.id"
              :label="item.fullName?item.fullName:item.enName"
              :value="item.id">
          </el-option>
        </el-select>
        <el-input v-model="form.msg" type="textarea" rows="4" placeholder="请输入请求内容"></el-input>
        <div class="submitBtn">
          <el-button type="primary" size="mini" @click="submitAddBuddy">确定</el-button>
          <el-button plain @click="buddy=false" size="mini">取消</el-button>
        </div>
        <div style="clear:both;"></div>
      </el-form>
    </el-dialog>


  </div>

</template>

<script>
import base from "@/api/common";
import commonjs from "@/api/common";

export default {
  directives: {
    'el-select-loadmore': {
      bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
            '.el-select-dropdown .el-select-dropdown__wrap'
        )
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
              this.scrollHeight - this.scrollTop <= this.clientHeight
          if (condition) {
            binding.value()
          }
        })
      }
    }
  },
  name: "buddyList",
  data() {
    return {
      friend: '',
      request: require('../../assets/img/friendRequest.png'),
      active: 1,
      activeType: 1,
      friendApply: {
        value: 0,
        finish: false,
        current: 1,
        size: 10,
        rows: []
      },
      buddy: false,
      form: {
        name: '',
        msg: ''
      },
      allDoctor: {
        current: 1,
        size: 10,
        finish: false,
      },
      region_DataList: [],
      regionDataList: [],
      id: localStorage.curUid,
      select_user: '',
      // 群聊
      groupChat: {
        size: 10,
        current: 1,
        finish: false,
        group: [],
        members: [],
        chatName: '',
        memberNum: ''
      },
      activeGroupChat: {},
      // 医生好友
      doctorChat: {
        size: 10,
        current: 1,
        finish: false,
        doctorList: []
      },
    }
  },
  inject: ['reload'],
  mounted() {
    if (this.activeType == 1) {
      this.getUnprocessed()
    }
  },
  methods: {
    // 搜索好友
    getSearch(value) {
      // 群聊
      this.groupChat.current = 1;
      this.groupChat.group.length = 0;
      this.groupChat.finish = false;
      this.getSearchChat()
      // 医生好友
      this.doctorChat.current = 1;
      this.doctorChat.doctorList.length = 0;
      this.doctorChat.finish = false;
      this.getFriendList()
      if (value == '') {
        this.loadGroup()
      }
    },
    change(type, index, item) {
      this.activeType = type
      this.active = index
      this.activeGroupChat = item
      if (this.activeType == 2) {
        this.groupChat.chatName = item.chatName ? item.chatName : (item.masterName + '创建的群聊')
        this.groupChat.memberNum = item.memberNum
        this.groupChat.members.length = 0
        this.getMemberListA(item.id)
      }
    },
    // 获取好友申请数目
    getUnprocessed() {
      let that = this;
      that.$ajax.get(base.api.communication.chat.unprocessed)
          .then(res => {
            if (res.data.status === 'success') {
              this.friendApply.value = res.data.data
            }
          })
    },
    // 获取好友申请列表
    getRequest() {
      if (this.friendApply.finish) {
        return;
      }
      let that = this;

      let params = {
        page: that.friendApply.current,
        size: that.friendApply.size
      };
      that.$ajax.post(base.api.communication.chat.friendApply, params)
          .then(res => {
            if (res.data.status === 'success') {
              if (this.friendApply.rows.length > 0 && res.data.current === 1) {
                return;
              }
              let totalPage = Math.ceil(res.data.total / res.data.size);
              if (res.data.current >= totalPage) {
                this.friendApply.finish = true;
              } else {
                this.friendApply.finish = false;
                this.friendApply.current++;
              }
              this.friendApply.rows.push(...res.data.rows)
            } else {
              that.$message.error('信息加载失败');
            }
          }).catch(err => {
        console.error(err);
        that.$message.error('信息加载失败');
      });
    },
    // 是否接受好友
    isAccept(id, status) {
      let that = this;
      that.$ajax.post(base.api.communication.chat.isAccept.replace('{id}', id).replace('{status}', status))
          .then((res) => {
            if (res.data.status == 'success') {
              this.reload()
              this.$emit('cl', 'second', null, 1)
              this.getRequest()
            }
          })
    },
    // 添加好友
    /*loadmore() {
     this.getArrs();
    },*/
    buddyDia() {
      this.buddy = true
      this.form.name = null
      this.allDoctor.current = 1;
      this.region_DataList.length = 0;
      this.allDoctor.finish = false;
    },
    getArrs() {
      if (this.allDoctor.finish) {
        return;
      }
      let data = {
        name: this.form.name,
        current: this.allDoctor.current,
        size: this.allDoctor.size,
      };
      // this.$ajax.post(base.basePath + 'auth/auth-doctor/page/base-info?page=' + this.allDoctor.current + '&&size=' + this.allDoctor.size).then(res => {
      this.$ajax.post(base.api.famousDoctor.conditionPage, data).then(res => {
        if (res.data.status === 'success') {
          if (this.region_DataList.length > 0 && res.data.current === 1) {
            return;
          }
          let totalPage = Math.ceil(res.data.total / res.data.size);
          if (res.data.current >= totalPage) {
            this.allDoctor.finish = true;
          } else {
            this.allDoctor.finish = false;
            this.allDoctor.current++;
          }
          this.region_DataList.push(...res.data.rows);
        }
      })
    },
    clear() {
      this.allDoctor.current = 1;
      this.region_DataList.length = 0;
      this.allDoctor.finish = false;
      this.getArrs()
      this.regionDataList = []
    },
    remoteMethod(query) {
      let vm = this;
      if (query.length >= 2) {
        this.form.name = query
        this.allDoctor.current = 1;
        this.region_DataList.length = 0
        this.allDoctor.finish = false;
        this.getArrs()
        vm.regionDataList = vm.region_DataList
      } else {
        vm.regionDataList = []
      }
    },
    searchSelect(id) {
      if (id == this.id) {
        this.$message.warning("不能添加自己");
        this.form.name = ''
        return;
      } else {
        this.doctorChat.doctorList.forEach((o, i) => {
          if (o.contactId == id) {
            this.$message.warning("已经成为好友，不可以添加");
            this.form.name = ''
            return;
          } else {
            this.select_user = id
          }
        })
      }
    },
    // 提交好友申请
    submitAddBuddy() {
      let name = this.form.name;
      if ($.trim(name).length === 0) {
        this.$message.warning("用户名不能为空");
        return;
      }
      let that = this;
      let params = {
        greetContent: this.form.msg
      }
      that.$ajax.post(base.api.communication.chat.applySubmit.replace('{id}', this.select_user), params)
          .then((res) => {
            if (res.data.status == 'success') {
              this.$message.success("提交申请成功");
              this.buddy = false
              // this.reload()
            }
          })
    },
    // 群聊
    loadGroup() {
      let that = this
      if (that.groupChat.finish) {
        return;
      }
      // 我创建的群聊列表:
      /*     let params={
             size:that.groupChat.size,
             current:that.groupChat.current
           }
          this.$ajax.post(base.basePath + 'communication/comm-chat/authorize/page/condition',params).then(res => {*/
      this.$ajax.get(base.basePath + 'communication/comm-chat/authorize/page/part-member?page=' + that.groupChat.current + '&size=' + that.groupChat.size).then(res => {
        if (res.data.status === 'success') {
          if (that.groupChat.group.length > 0 && res.data.current === 1) {
            return;
          }
          let totalPage = Math.ceil(res.data.total / res.data.size);
          if (res.data.current >= totalPage) {
            that.groupChat.finish = true;
          } else {
            that.groupChat.finish = false;
            that.groupChat.current++;
          }
          this.groupChat.group.push(...res.data.rows);
        }
      })
    },
    // 搜索与我相关的群聊
    getSearchChat() {
      let params = {
        keyword: this.friend
      }
      this.$ajax.post(base.api.communication.chat.groupSearch.replace('{keyword}', this.friend), params)
          .then((res) => {
            if (res.data.status === 'success') {
              this.groupChat.group = res.data.list
            }
          })
    },
    // 获取群成员
    getMemberListA(id) {
      let that = this
      that.$ajax.get(base.api.communication.chat.member.list.replace('{id}', id)).then(res => {
        if (res.data.status === 'success') {
          this.groupChat.members.push(...res.data.list)
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('成员信息加载失败');
      })
    },
    getFriendList() {
      let that = this
      if (that.doctorChat.finish) {
        return;
      }
      let params = {
        size: that.doctorChat.size,
        current: that.doctorChat.current,
        keyword: this.friend
      }
      this.$ajax.post(base.api.communication.chat.contacts, params).then(res => {
        if (res.data.status === 'success') {
          if (that.doctorChat.doctorList.length > 0 && res.data.current === 1) {
            return;
          }
          let totalPage = Math.ceil(res.data.total / res.data.size);
          if (res.data.current >= totalPage) {
            that.doctorChat.finish = true;
          } else {
            that.doctorChat.finish = false;
            that.doctorChat.current++;
          }
          this.doctorChat.doctorList.push(...res.data.rows);
        }
      })
    },
    // 群聊发消息
    setChat() {
      this.$emit('cl', 'first', this.activeGroupChat, 2)
    },
    // 点击医生好友
    setDoctorChat(item) {
      if (!item.contactId) {
        console.error('uid is null');
        return;
      }
      this.$ajax.post(base.api.communication.chat.create.replace('{uid}', item.contactId)).then(res => {
        if (res.data.status === 'success') {
          this.$emit('cl', 'first', res.data.id, 1)
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        console.error(err);
        this.$message.error('失败');
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/buddyList.scss";
</style>
